export default function sleep(milliseconds: number): Promise<void> {
    return new Promise(resolve => {
        if (typeof milliseconds !== "number" || milliseconds < 0) { 
            resolve() 
        }
        else {
            setTimeout(() => resolve(), milliseconds)
        }
    })
}